<template>
  <div>
    <!--头部信息-->
    <div class="factoring">
      <div class="factoring_tit w">
        <h2 class="factoring_h">融资租赁</h2>
        <div class="limit">
          <p>额度申请</p>
          <p>客户有意向平台发起融资申请时，需要先进行额度申请，平台对客户进行尽调，授信一定的额度，客户可在额度范围内进行融资申请。</p>
        </div>

        <div class="financing limit">
          <p>融资租赁申请</p>
          <p>可录入或导入设备明细，录入融资金额，选择融资模式、提交融资申请，平台审核通过后签订租赁合同，进入放款流程。</p>
        </div>
        <button class="factoring_btn">立即申请</button>
      </div>
    </div>
    <!--头部信息-->
    <!--主要内容-->
    <div class="factoring_main w">
      <div class="lease">
        <div class="presentation_l f_public">
          <div>直租</div>
          <p>借款人租赁设备，租赁公司付款给设备 供应商，借款人分期支付租金给租赁公 司，到期产权转移给借款人。 租赁公司需与供应商签订买卖</p>
        </div>
        <div class="presentation_r f_public">
          <div>回租</div>
          <p>借款人将设备抵押给租赁公司，获得流 动资金，然后分期支付租金给支付公司， 到期产权转移给借款人。 借款人需与租赁公司签订租赁合</p>
        </div>
      </div>
      <!--申请流程-->
      <div class="flow">
        <p class="flow_h tit_public colorF"><span class="tit_span">申请流程</span></p>
        <div class="flow_img">
          <img src="../../assets/images/lease.png" alt="">
        </div>
      </div>
      <!--申请流程-->


      <!--申请条件及所需资料-->
      <div class="condition">
        <p class="condition_h tit_public"><span class="tit_span">申请条件及所需资料</span></p>
        <ul class="condition_list">
          <li class="condition_li" v-for="(item,index) in conditionArr" :key="index">
            <span>{{item.compactName}}</span>
            <p>{{item.compactMain}}</p>
          </li>
        </ul>

      </div>
    </div>
    <!--主要内容-->
  </div>
</template>

<script>
  export default {
    // name: "factoring".
    data() {
      return {
        conditionArr:[
          {compactName:"01 合同信息",compactMain:"录入贸易基本信息，上 传合同附件，如果已经 录入过同样的合同则只 需要选择合同将会带出 合同信息"},
          {compactName:"02 发票信息",compactMain:"上传发票附件"},
          {compactName:"03 担保方信息",compactMain:"可选择录入担保方信息 ，加速融资进度，提高 融资比例可选择担保方 式，质押担保，抵押担 保，信用担保"},
          {compactName:"04 担保品信息",compactMain:"采用抵押担保模式需要 提供担保品信息（名称 ，数量价值等）"},
        ]  //申请条件附件
      }
    }
  }
</script>

<style scoped lang="scss">
  .w {
    width: 1140px;
    margin: 0 auto;
  }

  .colorF {
    color: #00C0FF
  }

  /*公共样式*/
  .tit_public {
    font-size: 26px;
    text-align: center;
    color: #00c0ff;
    margin: 74px 0 30px 0;
    .tit_span {
      border-bottom: 1px solid #00c0ff;
      padding-bottom: 5px;
    }
  }

  /*顶部介绍*/
  .factoring {
    width: 100%;
    height: 451px;
    background: url(../../assets/images/lease_bg.jpg) center center no-repeat;
    color: #fff;
    .factoring_tit {
      text-align: center;
      .factoring_h {
        font-size: 40px;
        padding: 58px 0;
      }
      .limit {
        border: 1px solid #fff;
        margin-bottom: 30px;
        p:first-of-type {
          font-size: 22px;
          padding: 12px 0;
        }
        p:last-of-type {
          font-size: 16px;
          padding-bottom: 12px;
        }

      }
      .factoring_btn {
        width: 160px;
        line-height: 38px;
        font-size: 18px;
        color: #fff;
        background: #00C0FF;
        border-radius: 20px;
        display: block;
        margin: 0 auto;
        outline: none;
        border: none;
        cursor: pointer;
      }
    }
  }

  /* 介绍*/
  .lease {
    box-sizing: border-box;
    height: 212px;
    background: #00C0FF;
    color: #fff;
    padding: 22px 48px;
    margin:60px 0 79px 0;
    @include clear;
    .f_public {
      width: 466px;
      border: 1px solid #fff;
      div {
        width: 140px;
        line-height: 166px;
        text-align: center;
        @include floatLeft;
        font-size: 26px;
      }
      p {
        width: 320px;
        line-height: 25px;
        @include floatRight;
        /*padding: 35px;*/
        box-sizing: border-box;
        padding: 30px 48px 0 0;
        font-size: 16px;
        text-align: justify;
      }
    }

    .presentation_l {
      @include floatLeft;

    }
    .presentation_r {
      @include floatRight;
    }
  }

  /*流程申请*/
  .flow {
    .flow_img{
      text-align: center;
      padding-top: 58px;
    }
  }

  /*申请条件*/
  .condition{
    .condition_list{
      padding: 20px 0 80px 0;
      @include clear;
      .condition_li{
        float: left;
        width: 212px;
        height: 225px;
        box-sizing: border-box;
        padding: 30px 12px 0 25px;
        background:  url(../../assets/images/masking.png);
        color:#fff;
        margin-right: 90px;
        &:last-of-type{
          margin-right: 0;
        }
        span{
          line-height: 45px;
          font-size: 20px;
        }
        p{
          font-size: 16px;
          line-height: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Lease.vue?c0a1258c